import React, {Component} from 'react';
import { ResponsiveBump } from '@nivo/bump'
import {Typography} from "@material-ui/core";
import moment from 'moment';

class ProvinceWithMostCases extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    /* -------- LIFECYCLE METHODS -------- */


    /* -------- FUNCTIONS -------- */
    getRank = (id, index, top4Data) => {
        let cases = []
        top4Data.forEach(p => {
            cases.push({id: p.id, cases: p.data[index].y})
        })

        cases.sort((a,b) => b.cases - a.cases)

        return cases.findIndex(e => e.id === id) + 1
    }

    /* -------- API CALLS -------- */


    /* -------- RENDERS -------- */
    render() {
        let {data} = this.props;
        let latestData = [];
        let top4Data = [];
        let bumpData = [];

        if(data.length === 0) {
            return <div/>
        }

        data.forEach(p => {
            if(p.id !== 'CA') {
                latestData.push({id: p.id, latest: p.data[p.data.length - 1].y, data: p.data})
            }
        })

        latestData.sort((a, b) => b.latest - a.latest)

        for(let i = 0; i < 4; i++) {
            let obj = {id: latestData[i].id, data: []}
            if(latestData[i].id === "AB") {
                latestData[i].data.unshift({x: '2020-03-2', y: 0})
            }
            let date = moment([2020, 2, 2]); //March 02, 2020
            latestData[i].data.forEach(d => {
                if(date.isSame(d.x)) {
                    obj.data.push({x: d.x, y: d.y})
                    date.date(date.date() + 7)
                }
            })
            top4Data.push(obj)
        }

        top4Data.forEach(p => {
            let dObj = {id: p.id, data: []}
            p.data.forEach((d, i) => {
                let rank = this.getRank(p.id, i, top4Data)
                dObj.data.push({x: moment(d.x).subtract(1, 'day').format('MMM DD'), y: rank, amt: d.y})
            })
            bumpData.push(dObj)
        })

        return <div className='section'>
            <Typography variant={'h4'} align={'left'} style={{marginBottom: 8}}>Provinces With Most Cases</Typography>
            <Typography variant={'subtitle1'} align={'left'} style={{marginBottom: 8}}>Week Over Week Since March 1st</Typography>
            <div style={{
                display: 'flex',
                height: 472,
                width: '100%',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                paddingBottom: 24
            }}>
                <ResponsiveBump
                    data={bumpData}
                    margin={{ top: 40, right: 16, bottom: 40, left: 60 }}
                    colors={{ scheme: 'spectral' }}
                    lineWidth={3}
                    activeLineWidth={6}
                    inactiveLineWidth={3}
                    inactiveOpacity={0.15}
                    pointSize={10}
                    activePointSize={16}
                    inactivePointSize={0}
                    pointColor={{ theme: 'background' }}
                    pointBorderWidth={3}
                    activePointBorderWidth={3}
                    pointComponent={CustomPoint}
                    pointBorderColor={{ from: 'serie.color' }}
                    axisTop={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: '',
                        legendPosition: 'middle',
                        legendOffset: -36
                    }}
                    axisRight={null}
                    axisBottom={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: '',
                        legendPosition: 'middle',
                        legendOffset: 32
                    }}
                    axisLeft={{
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: 'ranking',
                        legendPosition: 'middle',
                        legendOffset: -40
                    }}
                />
            </div>
        </div>
    }
}

const CustomPoint = (props) => {
    let { data, x, y, isActive, isInactive, size, color, borderColor, borderWidth } = props

    return (
        <g transform={`translate(${x}, ${y})`} style={{ pointerEvents: 'none' }}>
            <rect
                x={size * -0.5 - 4}
                y={size * -0.5 + 4}
                width={size + 26}
                height={size + 4}
                fill="rgba(0, 0, 0, .07)"
            />
            <rect
                x={size * -0.5 - 13}
                y={size * -0.5 - 2}
                width={size + 26}
                height={size + 4}
                fill={isActive ? '#fff' : color}
                stroke={borderColor}
                strokeWidth={borderWidth}
            />
            {isActive && (
                <text textAnchor="middle" y={4} fill={borderColor} fontSize={12}>
                    {Number(data.amt).toLocaleString('en')}
                </text>
            )}
            {isInactive && (
                <text textAnchor="middle" y={4} fill={borderColor}/>
            )}
        </g>
    )
}


export default ProvinceWithMostCases